import React, { useEffect } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal'
import ModalField from './ModalField'
import Table from '../../components/Table'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import { deleteStudyShift, getStudyShiftsList } from '../../actions/directoryBasicEducation'
import { getDatasetsAllList, getDatasetsList, getFieldAllList, getFields } from '../../actions/datasets'


export default function TableDescription() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { datasetsList } = useSelector(state => state.datasets)

  const [selectedItem, setSelectedItem] = useState(null)
  const [selected, setSelected] = useState(null)
  const [openField, setOpenField] = useState(false)
  const [confirmation, setConfirmation] = useState(false);

  useEffect(() => {
    dispatch(getDatasetsList())
  }, [])

  const openModal = (data) => () => {
    dispatch(getDatasetsAllList())
    setSelectedItem(data || {})
  }
  const openModalField = () => () => {
    setOpenField(true)
    dispatch(getFieldAllList(selected))
    dispatch(getFields(selected))
  }

  const closeModal = () => {
    setSelectedItem(null)
    setOpenField(false)
  }

  const goHome = () => navigate('/')

  const acceptConfirmation = () => {
    closeModal();
    dispatch(deleteStudyShift(confirmation.id));
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const renderLi = (data) => {
    const { dataset_id, dsname, dstranslate, dsdescript } = data
    return (
      <tr style={dataset_id == selected ? { backgroundColor: '#b5ccfb' } : {}}>
        <td onClick={() => setSelected(dataset_id)} onDoubleClick={openModal(data)}>{dsname}</td>
        <td onClick={() => setSelected(dataset_id)} onDoubleClick={openModal(data)}>{dstranslate}</td>
        <td onClick={() => setSelected(dataset_id)} onDoubleClick={openModal(data)}>{dsdescript}</td>
        <td><i className={styles.trash} onClick={() => setConfirmation({ id: dataset_id, name: dsname })}><BiTrash /></i></td>
      </tr>
    )
  }

  return (
    <div className={styles.wrapper} >
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
          acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      {selectedItem &&
        <Modal
          closeModal={closeModal}
          data={selectedItem}
          height={'430px'}
          addMode={!selectedItem?.dataset_id}
        />
      }
      {selected && openField &&
        <ModalField
          closeModal={closeModal}
          data={selected}
          height={'430px'}
        />
      }
      <h1>Описание таблиц</h1>

      <Table className={styles.tables}>
        <thead>
          <tr>
            <th>Название</th>
            <th>Наименование</th>
            <th>Описание</th>
            <th></th>
          </tr>
        </thead>
        <tbody>

          {datasetsList?.map(renderLi)}

        </tbody>
      </Table>

      <div style={{ display: 'flex', flexDirection: "row" }}>
        <Button
          style={{ padding: '.5rem 1.5rem', margin: '12px' }}
          onClick={openModal()}
        >
          <IoIosAdd size={30} />
          Добавить
        </Button>
        <Button
          style={{ padding: '.5rem 1.5rem', margin: '12px' }}
          onClick={openModalField()}
        >
          <IoIosAdd size={30} />
          Список полей
        </Button>
      </div>
    </div>
  )
}
